import { Component, OnInit, Renderer2 } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import { DispatchAndInvoiceRequestModel } from 'src/app/wings-mobile/models/dispatchingAndInvoicing/dispatch-and-invoice-request.model';
import { DispatchAndInvoiceResponseModel } from 'src/app/wings-mobile/models/dispatchingAndInvoicing/dispatch-and-invoice-response.model';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { VolLoadResponseModel } from '../../../../models/dispatchingAndInvoicing/vol-load-response.model';
import { DispatchingInvoicingService } from '../../../../services/outbound/dispatching-invoicing.service';
import { Utils } from "../../../../shared/constants/utils";
import { CaseStatus } from "../../../../shared/constants/case-status";
import { UserResourcesEnum } from "../../../../services/resource/user-resources.service";
import { NgIf, NgClass } from '@angular/common';
import { LoadInfoDisplayComponent } from './load-info-display/load-info-display.component';
import { CaseInfoDisplayComponent } from './case-info-display/case-info-display.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ResourceDirective } from '../../../../directives/resource.directive';
import { ButtonDirective } from 'primeng/button';
import { ExportChooseModalComponent } from './export-choose-modal/export-choose-modal.component';
import { InputGenericComponent } from '../../../../shared/input-generic/input-generic.component';
import { AlertCustomComponent } from '../../../../shared/alert-custom/alert-custom.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

export class RouteCurrent {
	user: string;
	outboundLoadUidK: number;
	bkLoadR: number;
	bkRouteC: string;
	vol: number;
	transportModalF: string;
	totalGrossWeightA: number;
	oldGrossWeightInformedA: number;
	isVisibleWeight: boolean = true;
}

@Component({
    selector: 'dispatching-invoicing',
    templateUrl: './dispatching-invoicing.component.html',
    styleUrls: ['./dispatching-invoicing.component.scss'],
    imports: [NgIf, LoadInfoDisplayComponent, CaseInfoDisplayComponent, FormsModule, InputTextModule, NgClass, ResourceDirective, ButtonDirective, ExportChooseModalComponent, InputGenericComponent, AlertCustomComponent, ConfirmDialogModule, TranslatePipe]
})
export class DispatchingInvoicingComponent implements OnInit {

	//ver uma maneira de melhorar isso depois
	YES = Utils.yes;
	resources = UserResourcesEnum;

	dispAndInvoiResponse: DispatchAndInvoiceResponseModel[];
	dispAndInvoiRequest: DispatchAndInvoiceRequestModel;

	errorMessage: string;
	errorFocus: string;
	errorTitle: string;
	showAlert: boolean = false;

	myRouteList: string[];
	routeCurrent: RouteCurrent;

	isMessage: boolean = false;
	message: string;

	showExportChooseModal: boolean = false;
	invoiceButtonLabel: string = this.translate.instant('button.invoice');
	invoiceButtonResource: UserResourcesEnum = this.resources.DISP_INVOI_CRUD;

	inputFields = [
		{
			name: "caseCode",
			id: "case_code",
			focus: true,
			value: null,
			action: "this.checkCase()",
			valid: false,
			disabled: false
		},
		{
			name: "caseType",
			id: "case_type",
			focus: false,
			value: null,
			action: "this.checkTypeCase()",
			valid: false,
			disabled: true
		}
	]

	constructor(public globals: Globals,
		private renderer: Renderer2,
		private beep: MessageBeep,
		private translate: TranslateService,
		private dispatchingInvoicingService: DispatchingInvoicingService,
		private confirmationService: ConfirmationService) {
		this.globals = globals;
		this.renderer = renderer;
		this.beep = beep;
		this.translate = translate;
		this.dispatchingInvoicingService = dispatchingInvoicingService;
		this.confirmationService = confirmationService;
	}

	ngOnInit(): void {
		this.myRouteList = [];
		if (!localStorage.getItem('myRouteList')) {
			localStorage.setItem('myRouteList', JSON.stringify(this.myRouteList));
		}
		this.setNullRouteCurrent();
		this.renderer.selectRootElement('#scanner_id').focus();
	}

	checkCase(backFromBoxEdition = false): void {
		this.genereteRequest();
		this.dispatchingInvoicingService.getInfoCase(this.dispAndInvoiRequest).subscribe({
			next: (res) => {
				if (res && res.length > 0 && res[0].outboundCasesTO.statusTO.bkStatusR >= 30) {
					this.dispAndInvoiResponse = res;
					if (this.routeCurrent.bkRouteC === null && this.dispAndInvoiResponse[0].bkLoadR === 0) {
						this.checkWay();
					} else if (this.isInOtherLoad()) {
						if (this.isNewBox()) {
							this.logicToNewLoad();
						} else {
							if (!backFromBoxEdition) this.logicForBoxInsertedInLoad();
						}
					} else {
						this.checkWay();
					}
					if (backFromBoxEdition) {
						this.focusCaseLabel();
					}
				} else {
					this.showErrorModal("modal.error", 'modal.invalidLabel', "case_code");
				}
				this.checkCommercialInvoice();
			}
		});
	}

	logicToNewLoad() {
		this.myRouteList = JSON.parse(localStorage.getItem('myRouteList'));
		if (this.myRouteList.includes(this.dispAndInvoiResponse[0].outboundRoutesTO.bkRouteC)) {
			this.checkWay();
		} else {
			this.confirm();
		}
	}

	isNewBox() {
		return this.dispAndInvoiResponse[0].bkLoadR === 0;
	}

	logicForBoxInsertedInLoad() {
		if (this.dispAndInvoiResponse[0].statusTO.statusUidK) {
			switch (this.dispAndInvoiResponse[0].statusTO.statusUidK) {
				case 90:
					this.showErrorModal("modal.error", "modal.inLoad", "case_code");
					this.updateInfoLoad();
					break;
				case 91:
					this.showErrorModal("modal.error", "modal.inClosedLoad", "case_code");
					break;
				default:
					break;
			}
		}
	}

	checkWay() {
		const partType = this.dispAndInvoiResponse[0].outboundCasesTO.bulk_F;
		if (partType === "BULK") {
			this.bulkWay();
		} else if (partType === "BIN") {
			this.binWay();
		}
	}

	bulkWay() {
		if (this.dispAndInvoiResponse[0].exportacaoF === Utils.yes) {
			this.disableBoxType();
			this.setCaseInLoad();
		} else {
			this.setCaseInLoad();
		}
	}

	setCaseInLoad() {
		this.insertCaseInLoad().subscribe({
			next: (res) => {
				this.dispAndInvoiResponse = res;
				this.updateInfoLoad();
				this.beep.successBeep();
				this.insertInMyRouteList();
			},
			error: (res) => {
				if (res.error && res.error.failureList) this.beep.showAlertCustom("modal.error", 'modal.' + res.error.failureList[0].messageCode.split('.').pop(), "case_code");
			}
		});
		this.inputFields[0].value = null;
		this.inputFields[0].focus = true;
	}

	binWay() {
		this.enableBoxType();
	}

	setNullRouteCurrent() {
		this.routeCurrent = new RouteCurrent();
	}

	enableCodeBoxLabel() {
		this.inputFields[1].disabled = true;
		this.inputFields[0].focus = true;
		this.inputFields[1].focus = false;
		this.inputFields[0].value = null;
		this.inputFields[1].value = null;
	}

	//Enable type of case for:
	//Local Market for type BIN
	//Exportation  for type BULK
	enableBoxType() {
		this.inputFields[1].disabled = false;
		this.inputFields[0].focus = false;
		this.inputFields[1].focus = true;
		this.renderer.selectRootElement('#scanner_id').focus();
	}

	//Disable type of case for:
	//Exportation for type bulk
	//without master box
	disableBoxType() {
		this.inputFields[1].disabled = true;
		this.inputFields[0].focus = true;
		this.inputFields[1].focus = false;
		this.renderer.selectRootElement('#scanner_id').focus();
	}

	isInOtherLoad() {
		const bkRouteC = this.dispAndInvoiResponse[0].outboundRoutesTO.bkRouteC;
		const bkLoadR = this.dispAndInvoiResponse[0].bkLoadR;
		if (bkRouteC === this.routeCurrent.bkRouteC && this.routeCurrent.bkLoadR === bkLoadR) {
			return false;
		} else {
			return true;
		}
	}

	updateInfoLoad() {
		this.updateVol();
		this.routeCurrent.user = this.dispAndInvoiResponse[0].bkLoadedUserC;
		this.routeCurrent.bkLoadR = this.dispAndInvoiResponse[0].bkLoadR;
		this.routeCurrent.outboundLoadUidK = this.dispAndInvoiResponse[0].outboundLoadUidK;
		this.routeCurrent.bkRouteC = this.dispAndInvoiResponse[0].outboundRoutesTO.bkRouteC;
		this.routeCurrent.transportModalF = this.dispAndInvoiResponse[0].transportModalF;
		this.routeCurrent.totalGrossWeightA = this.dispAndInvoiResponse[0].totalGrossWeightA;
		this.routeCurrent.outboundLoadUidK = this.dispAndInvoiResponse[0].outboundLoadUidK;
		this.routeCurrent.oldGrossWeightInformedA = this.dispAndInvoiResponse[0].outboundCasesTO.grossWeightInformedA;
	}

	updateVol() {
		if (this.isInOtherLoad()) {
			this.genereteRequestVol();
			this.dispatchingInvoicingService.getLoadVolum(this.dispAndInvoiRequest).subscribe({
				next: (res) => {
					const load: VolLoadResponseModel = res;
					this.routeCurrent.vol = load.amountCases;
				}
			});
		} else {
			this.routeCurrent.vol = this.routeCurrent.vol === null ? 1 : this.routeCurrent.vol + 1;
		}
	}

	insertInMyRouteList() {
		this.myRouteList = JSON.parse(localStorage.getItem('myRouteList'));
		if (this.dispAndInvoiResponse[0].bkLoadedUserC === this.globals.user.userName.toUpperCase()) {
			if (!this.myRouteList.includes(this.dispAndInvoiResponse[0].outboundRoutesTO.bkRouteC)) {
				this.myRouteList.push(this.dispAndInvoiResponse[0].outboundRoutesTO.bkRouteC);
				localStorage.setItem('myRouteList', JSON.stringify(this.myRouteList));
			}
		}
	}

	deleteInMyRouteList() {
		this.myRouteList = JSON.parse(localStorage.getItem('myRouteList'));
		if (this.routeCurrent.user && this.routeCurrent.user.toUpperCase() === this.globals.user.userName.toUpperCase()) {
			if (this.myRouteList.includes(this.routeCurrent.bkRouteC)) {
				this.myRouteList = this.myRouteList.filter(item => item != this.routeCurrent.bkRouteC);
				localStorage.setItem('myRouteList', JSON.stringify(this.myRouteList));
			}
		}
	}

	checkTypeCase(): void {
		this.inputFields[1].value = this.inputFields[1].value.toUpperCase();
		this.insertCaseInLoad().subscribe({
			next: (res) => {
				if (res && res.length > 0) {
					this.dispAndInvoiResponse = res;
					this.updateInfoLoad();
					this.enableCodeBoxLabel();
					this.beep.successBeep();
					this.renderer.selectRootElement('#scanner_id').focus();
					this.insertInMyRouteList();
				} else {
					this.showErrorModal("modal.error", 'modal.invalidBox', "case_type");
					this.inputFields[1].value = null;
				}
			},
			error: (res) => {
				if (res.error && res.error.failureList) this.beep.showAlertCustom("modal.error", 'modal.' + res.error.failureList[0].messageCode.split('.').pop(), "case_code");
				this.inputFields[0].value = null;
				this.inputFields[1].value = null;
			}
		});
	}

	insertCaseInLoad(): Observable<DispatchAndInvoiceResponseModel[]> {
		this.genereteRequest();
		return this.dispatchingInvoicingService.saveCaseCode(this.dispAndInvoiRequest)
	}

	genereteRequest() {
		this.dispAndInvoiRequest = new DispatchAndInvoiceRequestModel;
		this.dispAndInvoiRequest.bkSubDivisionUidD = this.globals.user.warehouse.bkSubDivisionUidD;
		this.dispAndInvoiRequest.caseCode = this.inputFields[0].value;
		this.dispAndInvoiRequest.caseType = this.inputFields[1].value;
		this.dispAndInvoiRequest.userC = this.globals.user.userName;
		if (this.dispAndInvoiResponse && this.dispAndInvoiResponse.length > 0
			&& this.dispAndInvoiResponse[0].bkLoadR) {
			this.dispAndInvoiRequest.bkLoadR = this.dispAndInvoiResponse[0].bkLoadR;
		}
	}

	genereteRequestVol() {
		this.dispAndInvoiRequest = new DispatchAndInvoiceRequestModel;
		this.dispAndInvoiRequest.bkSubDivisionUidD = this.globals.user.warehouse.bkSubDivisionUidD;
		this.dispAndInvoiRequest.caseCode = this.inputFields[0].value;
		this.dispAndInvoiRequest.caseType = this.inputFields[1].value;
		this.dispAndInvoiRequest.userC = this.dispAndInvoiResponse[0].bkLoadedUserC;
		if (this.dispAndInvoiResponse && this.dispAndInvoiResponse.length > 0
			&& this.dispAndInvoiResponse[0].bkLoadR) {
			this.dispAndInvoiRequest.bkLoadR = this.dispAndInvoiResponse[0].bkLoadR;
		}
	}

	buttonIsDisabled() {
		if (!this.dispAndInvoiResponse) {
			return true;
		}
		const dispatchBox = this.dispAndInvoiResponse.find(item => {
			if (item.outboundCasesTO.statusTO && item.outboundCasesTO.statusTO.bkStatusR) {
				return item.outboundCasesTO.statusTO.bkStatusR === CaseStatus.dispatch
			}
			return item;
		});
		return !this.routeCurrent.bkLoadR && !dispatchBox;
	}

	showCommercialInvoice(): boolean {
		return this.dispAndInvoiResponse && this.dispAndInvoiResponse[0].exportacaoF.toUpperCase() === Utils.yes &&
			(!this.dispAndInvoiResponse[0].commercialInvoice ||
				this.dispAndInvoiResponse[0].commercialInvoice === Utils.no)
	}

	executeAction(item) {
		eval(item.action);
	}

	showErrorModal(title: string, msg: string, focus?: string) {
		this.errorTitle = this.translate.instant(title);
		this.errorMessage = this.translate.instant(msg);
		this.errorFocus = focus;
		this.showAlert = true;
		this.beep.errorBeep();
	}

	hideErrorModal(elId) {
		this.inputFields.forEach(item => {
			if (item.id === elId) {
				item.value = null;
				item.focus = true;
				this.renderer.selectRootElement('#scanner_id').focus();
			}
		});
		this.showAlert = false;
	}

	confirm() {
		this.confirmationService.confirm({
			message: this.translate.instant('modal.wantNewLoad'),
			header: this.translate.instant('modal.confirmation'),
			acceptLabel: this.translate.instant('modal.yes'),
			rejectLabel: this.translate.instant('modal.no'),
			accept: () => {
				this.checkWay();
			},
			reject: () => {
				this.inputFields[0].value = null;
				this.inputFields[0].focus = true;
				this.renderer.selectRootElement('#scanner_id').focus();
			}
		});
	}

	dispatchAndInvoicing() {
		if (this.showCommercialInvoice()) {
			this.showExportChooseModal = true;
		} else {
			this.invoice(null);
		}
	}

	invoice(modal: string) {
		this.dispatchingInvoicingService.dispatchingAndInvoicing(this.routeCurrent.outboundLoadUidK,
			this.globals.user.warehouse.bkSubDivisionUidD, modal).subscribe({
				next: () => {
					this.beep.successBeep();
					this.setNullRouteCurrent();
					this.deleteInMyRouteList();
					this.resetScreen();
				},
				error: err => {
					if (err.error.failureList[0].messageCode.includes("wingsInvoiceError")) {
						this.deleteInMyRouteList();
						this.beep.showAlertCustom("modal.error", 'modal.wingsInvoiceError');
					} else {
						//TODO hablar con Edney sobre final de string para remover ' - '
						if (err.error.failureList) this.beep.showAlertCustom("modal.error", 'modal.' + err.error.failureList[0].messageCode.split('.').pop());
					}
				}
			})
	}

	checkCommercialInvoice() {
		if (this.showCommercialInvoice()) {
			this.invoiceButtonResource = this.resources.INVOI_EXPORT_CRUD;
			this.invoiceButtonLabel = this.translate.instant('button.commercialInvoice');
		} else {
			this.invoiceButtonResource = this.resources.DISP_INVOI_CRUD;
			this.invoiceButtonLabel = this.translate.instant('button.invoice')
		}
	}

	receiveSuccessBoxEdition(event) {
		this.inputFields[0].value = event;
		this.checkCase(true);
	}

	focusCaseLabel() {
		this.inputFields[0].value = "";
		this.inputFields[0].focus = true;
		this.inputFields[1].focus = false;
		this.renderer.selectRootElement('#scanner_id').focus();
	}

	resetScreen() {
		this.inputFields.forEach(input => input.focus = false);
		this.renderer.selectRootElement('#scanner_id').focus();
		this.inputFields[0].focus = true;
		this.dispAndInvoiResponse = null;
	}

	closeExportModal() {
		this.showExportChooseModal = false;
		this.focusCaseLabel();
	}

	closeModalAndInvoice(modal: string) {
		this.showExportChooseModal = false;
		this.invoice(modal);
	}

	closeModalAndError(message: string) {
		this.showErrorModal('modal.error', message, 'case_code');
	}
}

